import React from 'react';
import { Card, CardHeader, CardContent, CardActions, Button, Typography, Box, Avatar, makeStyles } from '@material-ui/core'
import { Rating } from '@material-ui/lab';
import { themeGreen } from '../../theme';
import Gallery from 'react-grid-gallery';

const useStyles = makeStyles(theme => ({    
    avatar : {},
    CustomCardAction: { margin: 0},
    Content: { paddingTop: 0 },
    RatingWidget: {},
    GalleryContainer: {
        clear: 'both',
        margin: '20px 0 30px',
        overflow: 'hidden'
    }
   
}))

function ReviewCard(props) {

    const classes = useStyles(themeGreen);
    const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };

    const styleSmall = () => {
        return {                        
            width: '100%',
            height: 'auto'
        }
    }

    const tileViewport = () => {
        return {            
            width: '150px',
            background: 'none'        
        }
    }
    let { username, rating, comment, p_comment, n_comment, date_created, pictures } = props;        

    let images;
    if (pictures) {
        console.log(pictures)
        images = pictures.map(p => {
            
            let v = p.picture.variants.find(v => v.size === "650" && v.format === "jpg")
            let th = p.picture.variants.find(v => v.size === "360" && v.format === "jpg")

            if (v)
            return {
                src: v && v.image,
                thumbnail: th && th.image                                
            }
        })
    }
    return (
        <Card className={props.elementClass || ''}>
            <CardHeader
                avatar={
                    <Avatar className={classes.avatar}>
                        {username.substring(0,1).toUpperCase() }
                    </Avatar>
                }
                title={`${username}`}
                subheader={
                    <Rating
                        className={classes.RatingWidget}
                        value={`${rating}`}
                        size="small"
                        readOnly
                    />
                }
                action={
                    <Typography className={classes.Date} variant='caption'>{date_created && new Date(date_created).toLocaleDateString("es-AR", dateOptions)}</Typography>
                }
                classes={{ action: classes.CustomCardAction }}
            />
            <CardContent className={classes.Content}>
                {
                    comment && 
                        <Box mb={2}>
                            <Typography variant="body2" color="textSecondary" component="p">                        
                                {comment}
                            </Typography>
                        </Box>
                    }
                {                    
                    p_comment && <Typography variant="body2" color="textSecondary" component="p">
                        <div><b>Lo mejor</b></div>
                        {p_comment}
                    </Typography>
                }
                {
                    n_comment && <React.Fragment><Box mt={2}></Box><Typography variant="body2" color="textSecondary" component="p">
                        <div><b>Lo peor</b></div>
                        {n_comment}
                    </Typography></React.Fragment>
                }
                {
                    images 
                        ? 
                        <div className={classes.GalleryContainer}>                            
                            <Gallery 
                                images={images} 
                                enableImageSelection={false}      
                                thumbnailStyle={styleSmall}
                                tileViewportStyle={tileViewport}                                
                                rowHeight={128}                                
                            />                            
                        </div>
                        : null
                }
            </CardContent>            
        </Card>
    )
}

export default ReviewCard;